import {AccessRule, Country, CountryRules, Rule} from "./types";


/**
 * Function to evaluate the access rule for a menu entry based on the user's data.
 *
 * @param rule - The rule to evaluate
 * @param userData - The user's data (roles or scopes) that will be used to evaluate the rule
 * @param countryCode - The country code for which the rule should be evaluated
 *
 * @returns `true` if the user has access to the menu entry, `false` otherwise
 */
export const evaluateRule = (
  rule: Rule,
  userData: string[],
  countryCode: Country,
): boolean => {

  // If rule is undefined, allow access
  if (!rule)
    return true;

  let content: AccessRule;
  if (rule.constructor === Object) {
    // CASE A: rule is country-specific - extract the content for the current country
    const countrySpecificContent: AccessRule | undefined = (rule as CountryRules)[countryCode];
    // If the content is `undefined`, deny access
    if (!countrySpecificContent)
      return false;
    content = countrySpecificContent;
  }
  else {
    // CASE B: rule is not country-specific
    const genericContent = rule as AccessRule;
    // If the content is `undefined`, allow access
    if (genericContent === "*")
      return true;
    content = genericContent;
  }

  // If the content is equal to "*", allow access
  if (content === "*")
    return true;

  // At this point, the content is a list of roles or scopes - check if the user has at least one of them
  if (userData.some((r) => content.includes(r)))
    return true;

  // If no match was found, deny access
  return false;
}